import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  Divider,
  Grid,
} from "@mui/material";
import ActivityRemarks from "../components/ActivitiesItems/ActivityRemarks";

export default function ViewActivityMenuModal({
  modalOpen,
  handleCloseModal,
  formValues,
  activityHistory,
}) {
  return (
    <Dialog maxWidth="md" open={modalOpen} onClose={handleCloseModal} fullWidth>
      <DialogTitle>{formValues.modalTitle}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ marginBottom: 2 }}>
          <Grid item xs={8}>
            <Typography variant="body1" fontWeight="bold">
              Start Date:
            </Typography>
            <Typography>{formValues.startDate}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Expected End Date:
            </Typography>
            <Typography>{formValues.expectedEndDate}</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body1" fontWeight="bold">
              Actual End Date:
            </Typography>
            <Typography>{formValues.actualEndDate}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="body1" fontWeight="bold">
              Assigned To:
            </Typography>
            <Typography>{formValues.assignedTo}</Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography variant="body1" fontWeight="bold">
              Status:
            </Typography>
            <Typography>{formValues.status}</Typography>
          </Grid>
        </Grid>

        {/* Divider and audit trail section */}
        <Divider sx={{ marginTop: 4, marginBottom: 2 }} />
        <Typography variant="h6">Activity Remarks</Typography>
        <Box sx={{ maxHeight: 200, marginTop: 1 }}>
          {activityHistory.length ? (
            <ActivityRemarks remarksData={activityHistory} />
          ) : (
            ""
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseModal} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
